import React from 'react';
import { RoutePermittedRole } from '../../shared/constants/AppEnums';

const Policies = React.lazy(() => import('./policies'));
const CreatePolicy = React.lazy(() => import('./policies/create-policy'));
const PolicyTabs = React.lazy(() => import('./policy-tabs'));
const CreatePolicyTab = React.lazy(
  () => import('./policy-tabs/create-policy-tab'),
);

export const policyConfig = [
  {
    permittedRole: RoutePermittedRole.user,
    path: '/policy/policies',
    element: <Policies />,
  },

  {
    permittedRole: RoutePermittedRole.user,
    path: '/policy/policies/create',
    element: <CreatePolicy />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/policy/policies/edit/:id',
    element: <CreatePolicy />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/policy/policy-tabs',
    element: <PolicyTabs />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/policy/policy-tabs/create',
    element: <CreatePolicyTab />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/policy/policy-tabs/edit/:id',
    element: <CreatePolicyTab />,
  },
];
